<template>
  <!-- 推进签约详情 -->
  <div class="promote-contract-detail record-detail" v-loading="loading">
    <div class="sign-info-tabs">
      <span class="tab-item" :class="{ active: activeTab === 'basic' }" @click="activeTab='basic'">基本信息</span>
      <span class="tab-item" :class="{ active: activeTab === 'paper' }" @click="activeTab='paper'">证件信息</span>
      <span class="tab-item" :class="{ active: activeTab === 'operation' }" @click="activeTab='operation'">运营信息</span>
      <span class="tab-item" :class="{ active: activeTab === 'seePatient' }" @click="activeTab='seePatient'">坐诊信息</span>
      <span class="tab-item" :class="{ active: activeTab === 'material' }" @click="activeTab='material'">物料信息</span>
      <span class="tab-item" :class="{ active: activeTab === 'other' }" @click="activeTab='other'">其他信息</span>
    </div>
    <div class="sign-info-content">
      <!-- 基本信息 -->
      <div v-show="activeTab === 'basic'" class="info-block">
        <div class="block-content">
          <!-- 科室 -->
          <div
            v-if="(showFormFieldKeyInfo['department_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo['department_formCode_' + signFormCode]['zhName'] }}</span>
              <span class="row-value">{{ formData['department_formCode_' + signFormCode] || '-' }}</span>
            </span>
          </div>
          <!-- 第一坐诊点 -->
          <div
            v-if="(showFormFieldKeyInfo['first_hospital_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo['first_hospital_formCode_' + signFormCode]['zhName'] }}</span>
              <span class="row-value">{{ (formData['first_hospital_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}</span>
            </span>
          </div>
          <!-- 简介 -->
          <div
            v-if="(showFormFieldKeyInfo['synopsis_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo['synopsis_formCode_' + signFormCode]['zhName'] }}</span>
              <span class="row-value">{{ formData['synopsis_formCode_' + signFormCode] || '-' }}</span>
            </span>
          </div>
          <!-- 擅长 -->
          <div
            v-if="(showFormFieldKeyInfo['virtue_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item">
              <span class="row-label">{{ showFormFieldKeyInfo['virtue_formCode_' + signFormCode]['zhName'] }}</span>
              <span class="row-value">{{ formData['virtue_formCode_' + signFormCode] || '-' }}</span>
            </span>
          </div>
          <!-- 个人形象照片 -->
          <div
            v-if="(showFormFieldKeyInfo['individuation_image_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['individuation_image_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData['individuation_image_formCode_' + signFormCode]"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData['individuation_image_formCode_' + signFormCode]"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData['individuation_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无医生个人形象照图片</div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <!-- 证件信息 -->
      <div v-show="activeTab === 'paper'" class="info-block">
        <div class="block-content">
          <!-- 执业证书 -->
          <div
            v-if="(showFormFieldKeyInfo['a1_image_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['a1_image_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData['a1_image_formCode_' + signFormCode]"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData['a1_image_formCode_' + signFormCode]"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData['a1_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无执业证书图片</div>
              </div>
            </span>
          </div>
          <!-- 资格证书 -->
          <div
            v-if="(showFormFieldKeyInfo['a2_image_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['a2_image_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData['a2_image_formCode_' + signFormCode]"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData['a2_image_formCode_' + signFormCode]"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData['a2_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无资格证书图片</div>
              </div>
            </span>
          </div>
          <!-- 职称证 -->
          <div
            v-if="(showFormFieldKeyInfo['a3_image_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['a3_image_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData['a3_image_formCode_' + signFormCode]"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData['a3_image_formCode_' + signFormCode]"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData['a3_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无职称证图片</div>
              </div>
            </span>
          </div>
          <!-- 身份证 -->
          <div
            v-if="(showFormFieldKeyInfo['id_card_image_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['id_card_image_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData['id_card_image_formCode_' + signFormCode]"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData['id_card_image_formCode_' + signFormCode]"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData['id_card_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无身份证图片</div>
              </div>
            </span>
          </div>
          <!-- 银行卡 -->
          <div
            v-if="(showFormFieldKeyInfo['bank_card_image_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['bank_card_image_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="image-list">
                <el-image
                  v-for="(img, idx) in formData['bank_card_image_formCode_' + signFormCode]"
                  :key="idx"
                  :src="img"
                  :preview-src-list="formData['bank_card_image_formCode_' + signFormCode]"
                  class="info-image"
                  fit="cover"
                />
                <div v-if="(formData['bank_card_image_formCode_' + signFormCode] || []).length === 0" class="empty">暂无银行卡图片</div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <!-- 运营信息 -->
      <div v-show="activeTab === 'operation'" class="info-block">
        <div class="block-content">
          <!-- 医生类型 -->
          <div
            v-if="(showFormFieldKeyInfo['doctor_type_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['doctor_type_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ (formData['doctor_type_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 是否接受医馆回访患者 -->
          <div
            v-if="(showFormFieldKeyInfo['is_allow_visit_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['is_allow_visit_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ (formData['is_allow_visit_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 医生自运营模式 -->
          <div
            v-if="(showFormFieldKeyInfo['operation_model_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['operation_model_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                <div v-for="(item, index) in (formData['operation_model_formCode_' + signFormCode] || [])" :key="index">
                  {{ item.questionItemLabel }}
                </div>
                <div v-if="(formData['operation_model_formCode_' + signFormCode] || []).length === 0">-</div>
              </div>
            </span>
          </div>
          <!-- 自媒体账号所有权 -->
          <div
            v-if="(showFormFieldKeyInfo['account_owner_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['account_owner_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ (formData['account_owner_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 目前微信累计添加患者数 -->
          <div
            v-if="(showFormFieldKeyInfo['sum_patient_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['sum_patient_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ formData['sum_patient_formCode_' + signFormCode] || '-' }}
              </div>
            </span>
          </div>
          <!-- 是否自带患者 -->
          <div
            v-if="(showFormFieldKeyInfo['is_patient_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['is_patient_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ (formData['is_patient_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 自带患者的方法 -->
          <div
            v-if="(showFormFieldKeyInfo['in_patient_way_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['in_patient_way_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ (formData['in_patient_way_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 已确定的运营策略 -->
          <div
            v-if="(showFormFieldKeyInfo['operation_profile_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['operation_profile_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ (formData['operation_profile_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
        </div>
      </div>

      <!-- 坐诊信息 -->
      <div v-show="activeTab === 'seePatient'" class="info-block">
        <div class="block-content">
          <!-- 首次坐诊日期 -->
          <div
            v-if="(showFormFieldKeyInfo['first_date_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['first_date_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ formData['first_date_formCode_' + signFormCode] || '-' }}
              </div>
            </span>
          </div>
          <!-- 叫号规则 -->
          <div
            v-if="(showFormFieldKeyInfo['call_rule_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['call_rule_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ (formData['call_rule_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
          <!-- 放号规则 -->
          <div
            v-if="(showFormFieldKeyInfo['create_rule_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['create_rule_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ formData['create_rule_formCode_' + signFormCode] || '-' }}
              </div>
            </span>
          </div>
          <!-- 挂号费 -->
          <div
            v-if="(showFormFieldKeyInfo['register_price_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['register_price_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ formData['register_price_formCode_' + signFormCode] || '-' }}
              </div>
            </span>
          </div>
          <!-- 加号费 -->
          <div
            v-if="(showFormFieldKeyInfo['add_register_price_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['add_register_price_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ formData['add_register_price_formCode_' + signFormCode] || '-' }}
              </div>
            </span>
          </div>
          <!-- 坐诊时间和坐诊分馆 -->
          <div
            v-if="(showFormFieldKeyInfo['practice_time_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['practice_time_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ formData['practice_time_formCode_' + signFormCode] || '-' }}
              </div>
            </span>
          </div>
          <!-- 到馆后每周坐诊次数 -->
          <div
            v-if="(showFormFieldKeyInfo['practice_count_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['practice_count_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ formData['practice_count_formCode_' + signFormCode] || '-' }}
              </div>
            </span>
          </div>
        </div>
      </div>

      <!-- 物料要求 -->
      <div v-show="activeTab === 'material'" class="info-block">
        <div class="block-content">
          <!-- 物料制作需求 -->
          <div
            v-if="(showFormFieldKeyInfo['materiel_require_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['materiel_require_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                <div v-for="(item, index) in (formData['materiel_require_formCode_' + signFormCode] || [])" :key="index">
                  {{ item.questionItemLabel }}
                </div>
                <div v-if="(formData['materiel_require_formCode_' + signFormCode] || []).length === 0">-</div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <!-- 其他事项 -->
      <div v-show="activeTab === 'other'" class="info-block">
        <div class="block-content">
          <!-- 医生其他需求 -->
          <div
            v-if="(showFormFieldKeyInfo['other_info_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['other_info_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ formData['other_info_formCode_' + signFormCode] || '-' }}
              </div>
            </span>
          </div>
          <!-- 引进到馆审批确定人 -->
          <div
            v-if="(showFormFieldKeyInfo['auditer_formCode_' + signFormCode] || {})['isShow']"
            class="info-row"
          >
            <span class="info-row-item block">
              <span class="row-label">{{ showFormFieldKeyInfo['auditer_formCode_' + signFormCode]['zhName'] }}</span>
              <div class="row-value">
                {{ (formData['auditer_formCode_' + signFormCode] || []).map(item => item.questionItemLabel).join('、') || '-' }}
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'

const signFormCode = 'FR012' // 推进签约表单编码

export default {
  name: 'PromoteContractDetail',
  data() {
    return {
      loading: false,
      activeTab: 'basic', // 默认显示基本信息
      originOptionsInfo: {},
      showFormFieldKeyInfo: {},
      signFormCode,
      formData: {}
    }
  },
  methods: {
    async init(formCodeList) {
      this.loading = true
      try {
        await this.getFormFieldList(formCodeList)
        await this.getFormData(formCodeList)
      } catch (error) {
        console.error('获取表单字段配置信息失败', error)
      } finally {
        this.loading = false
      }
    },

    async getFormFieldList(formCodeList = []) {
      const {
        formData,
        showFormFieldKeyInfo,
        originOptionsInfo
      } = await formFlow.getFormFieldList(formCodeList)

      this.formData = formData
      this.showFormFieldKeyInfo = showFormFieldKeyInfo
      this.originOptionsInfo = originOptionsInfo
    },

    // 获取表单数据
    async getFormData(formCodeList = []) {
      const { formData } = this
      for (const formCode of formCodeList) {
        const data = await formFlow.getFormData({
          instanceId: this.currentRecordInfo.doctorStageId,
          stepCode: this.currentRecordInfo.stepCode,
          stepId: this.currentRecordInfo.stepId,
          formCode,
          doctorId: this.currentRecordInfo.doctorId
        })
        // console.log('获取详情页面表单页面数据', data)
      
        // 表单获取的数据为空，则初始化表单id
        if (utils.getDataType(data) === 'object' && Object.keys(data.formData).length === 0) {
          continue
        }

        for(const key in data.formData) {
          const item = data.formData[key] || {}
          const valueList = utils.getDataType(item.value) === 'array' ? item.value : []
          if ([
            'individuation_image_formCode_' + signFormCode, // 执业证书
            'a1_image_formCode_' + signFormCode, // 执业证书
            'a2_image_formCode_' + signFormCode, // 资格证书
            'a3_image_formCode_' + signFormCode, // 职称证
            'id_card_image_formCode_' + signFormCode, // 身份证
            'bank_card_image_formCode_' + signFormCode, // 银行卡
          ].includes(key)) {
            // 图片
            formData[key] = valueList.map(item => this.imageBaseUrl + item || '')
          } else {
            if ([1, 2].includes(item.inputType)) {
              // 单选/多选
              formData[key] = (this.originOptionsInfo[key] || []).filter(item => valueList.includes(item.questionItemValue))
            } else {
              formData[key] = valueList[0] || formData[key] || ''
            }
          }
        }
        this.formData = formData
      }
    },
  },
  created() {
    const formCodeList = [signFormCode]
    this.init(formCodeList)
  },
  props: {
    currentRecordInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    imageBaseUrl() {
      return process.env.VUE_APP_ENV === 'production' ? 'https://image.scxinglin.com' : 'https://testdev.scxinglin.com'
      // return 'https://image.scxinglin.com'
    }
  }
}

</script>

<style scoped lang='less'>
@import '~@/views/DoctorVisitLTC/style/recordDetail.less';

// 推进签约信息
.promote-contract-detail {
  .sign-info-tabs {
    display: inline-flex;
    margin-bottom: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    overflow: hidden;

    .tab-item {
      padding: 6px 8px;
      border-right: 1px solid #e0e0e0;
      cursor: pointer;

      &:last-child {
        border-right: none;
      }

      &.active {
        background-color: #1890FF;
        color: #FFF;
      }
    }
  }

  .block-content {
    padding: 0 6px;
  }

  .row-label {
    width: 72px !important;
  }
}
</style>